import { ReactNode } from "react";
import { useLocalStorage } from "hooks/useLocalStorage";
import CloseButton from "components/CloseButton";

interface DismissibleInfoBoxProps {
  id: string;
  icon?: ReactNode;
  children: ReactNode;
  className?: string;
}

export default function DismissibleInfoBox({
  id,
  icon,
  children,
  className,
}: DismissibleInfoBoxProps) {
  // const [dismissed, setDismissed] = useLocalStorage(`dismissible-${user?.apiKey}-${id}`, false);
  const [dismissed, setDismissed] = useLocalStorage(`dismissible-${id}`, false);

  if (dismissed) {
    return null;
  }

  return (
    <div
      className={
        className ??
        "flex items-center gap-2 px-4 py-3 rounded-md bg-amber-50 border border-amber-300 text-amber-800 text-sm"
      }
    >
      {icon}
      <div className="flex-1">{children}</div>
      <CloseButton onPress={() => setDismissed(true)} />
    </div>
  );
}
